var _excluded = ["id", "component", "commonStyle", "type"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useRef, useState } from "react";
import ItemView from "./components/item-view";
import Navigation from "./components/navigation";
import useNavigation from "../assets/hooks/useNavigation";
import { getStyle } from "../assets/utils";
import { EComponent } from "../modules/enum";
import classnames from 'classnames';
import { isNumber } from 'lodash-es';
import "./index.scss";
/**
 * 格式化构造 Viewer 组件必要的数据信息
 */
var formatInfo = function formatInfo(value) {
  var currentDevice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pc';
  try {
    var parsedValue = typeof value === 'string' ? JSON.parse(value || '{}') : value;
    var nameMapping = Object.values(EComponent).reduce(function (acc, cur) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, true));
    }, {});
    var modules = ((parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.modules) || []).filter(function (_ref) {
      var component = _ref.component,
        hidden = _ref.hidden;
      return !hidden && nameMapping[component];
    });
    var pageStyle = (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.pageStyle) || {};
    var _ref2 = (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.navInfo) || {},
      isCheckedAll = _ref2.isCheckedAll,
      navIds = _ref2.navIds;
    return {
      modules: modules,
      pageStyle: pageStyle,
      navList: function () {
        if (currentDevice === 'mobile') {
          return [];
        }
        return isCheckedAll ? modules : modules === null || modules === void 0 ? void 0 : modules.filter(function (module) {
          return navIds === null || navIds === void 0 ? void 0 : navIds.includes(module === null || module === void 0 ? void 0 : module.id);
        });
      }()
    };
  } catch (err) {
    console.error('Error parsing value', err);
    return {
      modules: [],
      navList: [],
      pageStyle: {}
    };
  }
};
export default function Viewer(props) {
  var value = props.value,
    _props$currentDevice = props.currentDevice,
    currentDevice = _props$currentDevice === void 0 ? 'pc' : _props$currentDevice,
    gettingCmsDetail = props.gettingCmsDetail;
  var _useState = useState(formatInfo(value)),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    modules = _useState2$.modules,
    navList = _useState2$.navList,
    pageStyle = _useState2$.pageStyle,
    setRenderInfo = _useState2[1];
  useEffect(function () {
    setRenderInfo(formatInfo(value, currentDevice));
  }, [value, currentDevice]);
  var containerRef = useRef(null);
  var showNavigation = useNavigation(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current);
  return modules !== null && modules !== void 0 && modules.length ? /*#__PURE__*/React.createElement("div", {
    className: "cms-viewer",
    ref: containerRef,
    style: getStyle(pageStyle)
  }, modules === null || modules === void 0 ? void 0 : modules.map(function (module, index) {
    var _module$data;
    var id = module.id,
      component = module.component,
      _module$commonStyle = module.commonStyle,
      commonStyle = _module$commonStyle === void 0 ? {} : _module$commonStyle,
      type = module.type,
      rest = _objectWithoutProperties(module, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      "data-id": id,
      "data-spm": "c_module_".concat(component, "_").concat(id),
      key: id,
      style: _objectSpread(_objectSpread({}, getStyle(commonStyle)), (commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.backgroundScheme) === (pageStyle === null || pageStyle === void 0 ? void 0 : pageStyle.backgroundScheme) && {
        background: 'transparent'
      }),
      className: classnames('cms-module-wrap aplus-module-auto-exp', _defineProperty(_defineProperty({
        'is-full': module === null || module === void 0 || (_module$data = module.data) === null || _module$data === void 0 ? void 0 : _module$data.enableFullScreen
      }, "theme-bg-".concat(commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.backgroundScheme), isNumber(commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.backgroundScheme)), "theme-color-".concat(commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.colorScheme), isNumber(commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.colorScheme))),
      "data-module-id": id,
      "data-module-index": index,
      "data-component": component
    }, /*#__PURE__*/React.createElement(ItemView, _extends({}, rest, {
      module: module,
      component: component,
      currentDevice: currentDevice,
      gettingCmsDetail: gettingCmsDetail
    })));
  }), navList !== null && navList !== void 0 && navList.length && showNavigation ? /*#__PURE__*/React.createElement("div", {
    className: "preview-navigation-fixed"
  }, /*#__PURE__*/React.createElement(Navigation, {
    modules: navList
  })) : null) : null;
}